import {Pipe, PipeTransform} from '@angular/core';
import {PRICE_QUALIFIERS} from '../../constants/price.constansts';
import {PriceQualifier} from '../../enums/price.enum';

@Pipe({
  name: 'priceQualifier'
})
export class PriceQualifierPipe implements PipeTransform {

  transform(value: string | number, HTMLLabel: boolean = false): string {
    const priceQualifierId = Number(value);
    if ((typeof priceQualifierId !== 'number')
      || isNaN(priceQualifierId)
      || PriceQualifier.DEFAULT === priceQualifierId) {
      return undefined;
    }

    const priceQualifier = PRICE_QUALIFIERS.filter(entry => entry.id === priceQualifierId).pop();
    return HTMLLabel ? priceQualifier?.HTMLLabel : priceQualifier?.label;
  }

}
